import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';

const Radio = (props) => {
  const ID = uniqueId('radio-');

  return (
    <div className={`radio-input ${props.className || ''}`}>
      <input
        className=""
        type="radio"
        id={ID}
        value={props.value}
        onChange={(e) => { props.onChange(e, e.target.checked); }}
        disabled={props.disabled}
        checked={props.checked}
      />
      <label htmlFor={ID}>
        {props.label}
      </label>
    </div>
  );
}

export default Radio;
